import { TableRow, TableCell, TableBody } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';

import {
  CustomButton,
  CustomTable,
  CustomTableContainer,
  CustomTableHead,
  CustomTableRow,
  MainContainer,
} from './BillingInvoices.styles';

type Billing = {
  type: string;
  amount: number;
  due: string;
  status: 'Paid' | 'Failed';
  reason?: string;
};

const mockData: Billing[] = [
  {
    type: 'Premium - Monthly',
    amount: 15,
    due: '24 August 2022',
    status: 'Failed',
    reason: 'Insufficient Funds',
  },
  {
    type: 'Premium - Monthly',
    amount: 15,
    due: '24 July 2022',
    status: 'Paid',
  },
  {
    type: 'Premium - Monthly',
    amount: 15,
    due: '24 June 2022',
    status: 'Paid',
  },
  {
    type: 'Premium - Monthly',
    amount: 15,
    due: '24 May 2022',
    status: 'Paid',
  },
  {
    type: 'Premium - Monthly',
    amount: 15,
    due: '24 Apr 2022',
    status: 'Paid',
  },
  {
    type: 'Premium - Monthly',
    amount: 15,
    due: '24 Mar 2022',
    status: 'Paid',
  },
  {
    type: 'Premium - Monthly',
    amount: 15,
    due: '24 Feb 2022',
    status: 'Paid',
  },
];

const BillingInvoices = () => {
  return (
    <MainContainer>
      <Typography fontSize={25}>Billing / Invoices</Typography>
      <CustomTableContainer>
        <CustomTable size="small" aria-label="a dense table">
          <CustomTableHead>
            <TableRow>
              <TableCell>
                <Typography fontSize={15} color="mainGrey">
                  Type
                </Typography>
              </TableCell>
              <TableCell>
                <Typography fontSize={15} color="mainGrey">
                  Amount
                </Typography>
              </TableCell>
              <TableCell>
                <Typography fontSize={15} color="mainGrey">
                  Due
                </Typography>
              </TableCell>
              <TableCell>
                <Typography fontSize={15} color="mainGrey">
                  Status
                </Typography>
              </TableCell>
              <TableCell>
                <Typography fontSize={15} color="mainGrey">
                  Reason
                </Typography>
              </TableCell>
              <TableCell>
                <Typography fontSize={15} color="mainGrey">
                  Action
                </Typography>
              </TableCell>
            </TableRow>
          </CustomTableHead>
          <TableBody>
            {mockData.map((row) => (
              <CustomTableRow $status={row.status}>
                <TableCell scope="row">
                  <Typography fontSize={15}>{row.type}</Typography>
                </TableCell>
                <TableCell scope="row">
                  <Typography fontSize={15} color="primary">
                    ${row.amount}
                  </Typography>
                </TableCell>
                <TableCell scope="row">
                  <Typography fontSize={15} color="mainGrey">
                    {row.due}
                  </Typography>
                </TableCell>
                <TableCell scope="row">
                  <Typography fontSize={15} color="mainGrey">
                    {row.status}
                  </Typography>
                </TableCell>
                <TableCell scope="row">
                  <Typography fontSize={15} color="mainGrey">
                    {row.reason}
                  </Typography>
                </TableCell>
                <TableCell scope="row">
                  {row.status === 'Failed' ? (
                    <CustomButton>Pay Now</CustomButton>
                  ) : (
                    <CustomButton>Download Invoice</CustomButton>
                  )}
                </TableCell>
              </CustomTableRow>
            ))}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </MainContainer>
  );
};

export default BillingInvoices;
